<app-header></app-header>
<app-toaster></app-toaster>
<app-modal></app-modal>
<app-boleto-modal></app-boleto-modal>
<app-pix-modal></app-pix-modal>
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-footer></app-footer>
